import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ShareScreenIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsxs("g", {
                        children: [
                            _jsx("path", {
                                d: "M13.054 16.825l-.013-6.257 1.602 1.601c.4.4.998.399 1.398-.001.2-.2.313-.37.313-.67 0-.3-.11-.529-.31-.729L12.74 7.468a.801.801 0 00-.3-.2 1.108 1.108 0 00-.392-.075c-.13.003-.3.032-.408.075-.108.042-.2.1-.3.2l-3.306 3.306c-.4.4-.39.99.01 1.39.4.4.99.41 1.39.01l1.606-1.606-.1 6.198c.006 1.41 2.091 1.442 2.113.059z"
                            }),
                            _jsx("path", {
                                d: "M20 4H4a3 3 0 00-3 3v11a3 3 0 003 3h16a3 3 0 003-3V7a3 3 0 00-3-3zm0 2a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h16z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
ShareScreenIcon.isCarinaIcon = true;
export default ShareScreenIcon;
